export default {
  works: {
    works_page_index_title: 'dossiers en cours',
    work_created: 'le dossier a été ajouté',
    work_updated: 'ce dossier a été mis a jour',
  }
}
